import ViewSalesUserPage from "../../../component/users/sales/ViewSalesUser"

 
 
function ViewSalesUser() {
  return (
    <div className='page-body'>

       < ViewSalesUserPage/>
        </div>
  )
}

export default ViewSalesUser